import { render, staticRenderFns } from "./BusinessActivityStatementQuarter.vue?vue&type=template&id=0f92f5a8&scoped=true"
import script from "./BusinessActivityStatementQuarter.vue?vue&type=script&lang=js"
export * from "./BusinessActivityStatementQuarter.vue?vue&type=script&lang=js"
import style0 from "./BusinessActivityStatementQuarter.vue?vue&type=style&index=0&id=0f92f5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f92f5a8",
  null
  
)

export default component.exports